import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PriceService } from "src/app/dashboard/price/price.service";
import { GoldCard } from "src/app/model/savings-plan/gold-card";
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";

@Injectable({
  providedIn: "root",
})
export class GoldCardService {
  constructor(
    private restApiService: RestApiService,
    private priceService: PriceService
  ) {}

  endpoint = "goldcard/";

  getGoldCardList(): Observable<GoldCard[]> {
    return this.priceService.goldCardList
  }

  convertToGoldCard(convertToGoldCardRequest) {
    return this.restApiService.post(
      ServerType.WALLET,
      this.endpoint + "convert-to-goldcard",
      {
        priceJwt: this.priceService.priceJwt.value,
        ...convertToGoldCardRequest,
      }
    );
  }
}
